import React from "react";
import { PropTypes } from "prop-types";
import { TopTrendingListLoader } from "administration/analytics/components";
import { MrbContentLoader } from "mrb/components/loader";
import { numberFormatter } from "common/utils";
import { MrbRouterLink } from "mrb/core/infrastructure/router";
import { map } from "lodash";
import { observer } from "mobx-react";

function ProducerPreviewMostPopularContentTemplate({ producerPreviewViewStore }) {
    const { loaderStore, mostPopularContent } = producerPreviewViewStore;
    return (
        <div>
            <h1 className="u-type--base u-mar--bottom--sml">Most Popular Content</h1>
            <div className="c-card--primary c-card--med">
                <MrbContentLoader
                    loaderStore={loaderStore}
                    loaderRender={() => <TopTrendingListLoader row={5} noButton />}
                >
                    {() => (
                        <div className="u-animation--fadeIn">
                            {mostPopularContent && mostPopularContent.length > 0 ? (
                                <div>
                                    {map(mostPopularContent, (item, index) => (
                                        <PlaybackItem
                                            index={index}
                                            item={item}
                                            key={item.stationId || item.podcastId}
                                        />
                                    ))}
                                </div>
                            ) : (
                                <EmptyState />
                            )}
                        </div>
                    )}
                </MrbContentLoader>
            </div>
        </div>
    );
}

ProducerPreviewMostPopularContentTemplate.propTypes = {
    producerPreviewViewStore: PropTypes.object.isRequired,
};

function PlaybackItem({ index, item }) {
    let title, route, isPremium, params;
    if (item.station) {
        title = item.station.title;
        isPremium = item.station.isPremium;
        route = "master.administration.analytics.station-activity";
        params = { id: item.station.id };
    } else if (item.podcast) {
        title = item.podcast.title;
        isPremium = item.podcast.isPremium;
        route = "master.administration.analytics.podcast-activity";
        params = { id: item.podcast.id };
    }
    return (
        <div className="c-analytics__list__item">
            <div className="u-display--flex u-display--flex--ai--baseline">
                <span className="u-mar--right--tny">{index + 1}.</span>
                <i
                    className={`u-icon u-icon--med u-mar--right--tny u-icon--${item.stationId ? "stations" : "podcasts"
                        }`}
                />
                <MrbRouterLink routeName={route} params={params} className={"c-analytics__list__title"}>
                    {title}
                    {isPremium && <i className="u-icon u-icon--base u-mar--left--tny u-mar--bottom--micro u-icon--premium" />}
                </MrbRouterLink>
            </div>
            {numberFormatter.format(item.playbacks)}
        </div>
    );
}

function EmptyState() {
    return (
        <div className="c-empty-state--no-results c-empty-state--no-results--sml">
            <i className="u-icon--empty u-icon--empty--sml u-icon--empty--shuffle u-mar--bottom--sml" />
            <h3>No activity data</h3>
            <p>There are no detected playbacks.</p>
        </div>
    );
}

export default observer(ProducerPreviewMostPopularContentTemplate);
